import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { openBillingInformationPage } from "app/common/hrefs";
import { NO_TOUCH_PURCHASE_TRANSLATIONS } from "app/components/no-touch-purchase-modal/translations";
import { openHooksModalV5 } from "app/services/ModalService";
import { allTrackers } from "app/services/track/track";

import paymentFailureIllustration from "../../images/alert.svg";
import { Actions, ImageFailed, TextFailed } from "../../SwitchPackageStage.styled";

export const StagePaymentFailureIcon = () => (
    <ImageFailed
        src={paymentFailureIllustration}
        alt="payment failure"
    />
);

interface IStagePaymentFailureDescription {
    targetProductName?: string;
}

export const StagePaymentFailureDescription = ({ targetProductName }: IStagePaymentFailureDescription) => {
    const { translate } = useTranslate();

    const handleUpdatePaymentMethodClick = () => {
        allTrackers.dispatchTrackEvent(
            "popup",
            "click",
            `payment failure change popup/update payment method/${targetProductName}`,
        );
        openBillingInformationPage();
    };

    const handleContactBillingClick = () => {
        allTrackers.dispatchTrackEvent(
            "popup",
            "click",
            `payment failure change popup/contact billing/${targetProductName}`,
        );
        openHooksModalV5("ContactUs", undefined, "ContactUsPaymentFailure", "GetLoading");
    };

    return (
        <Flex
            flexDirection="column"
            alignItems="center"
            gap="24px"
            width="100%"
        >
            <Text
                fontVariant="body1"
                color={colorsPalettes.carbon[300]}
                textAlign="center"
            >
                {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.paymentFailure.description)}
            </Text>

            <Actions>
                <Button
                    type="primary"
                    onClick={handleUpdatePaymentMethodClick}
                    data-automation="package-switcher-stage-payment-failure-update-payment"
                >
                    {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.paymentFailure.updatePaymentMethod)}
                </Button>

                <Text
                    fontVariant="body1"
                    color={colorsPalettes.carbon[300]}
                    textAlign="center"
                >
                    {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.paymentFailure.needHelp)}{" "}
                    <TextFailed
                        fontVariant="body1"
                        color={colorsPalettes.blue[400]}
                        onClick={handleContactBillingClick}
                        data-automation="package-switcher-stage-payment-failure-contact-billing"
                    >
                        {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.paymentFailure.contactBilling)}
                    </TextFailed>
                </Text>
            </Actions>
        </Flex>
    );
};
